import { render, staticRenderFns } from "./EligibilityReasons.vue?vue&type=template&id=641d2390&scoped=true&"
import script from "./EligibilityReasons.vue?vue&type=script&lang=js&"
export * from "./EligibilityReasons.vue?vue&type=script&lang=js&"
import style0 from "./EligibilityReasons.vue?vue&type=style&index=0&id=641d2390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641d2390",
  null
  
)

export default component.exports